export class KoncentroBaseModel {
  public dto?: string;
  public ts_ins?: string;
  public ts_upd?: string;
  public ts_del?: string;
  public user_ins_id?: number;
  public user_upd_id?: number;
  public user_del_id?: number;
  public flg_kf?: string;
  public flg_dpl?: string;
  public flg_state?: number;
}



// WEBPACK FOOTER //
// ./src/app/models/koncentro-base.model.ts